import Yup from '../yup';
import child from './child';
import _ from 'lodash';

const applicationType = {
  vary_resp_other: Yup.string().when('app_types', {
    is: (app_types: string[]) =>
      Array.isArray(app_types) && app_types.includes('AV'),
    then: Yup.string()
      .required('Please provide information about what you want changed on the order')
      .max(150, 'Character limit exceeded for conditions you want to change'),
  }),

  child_action: Yup.array().when('app_types', {
    is: (app_types: string[]) =>
      Array.isArray(app_types) && app_types.includes('AV'),
    then: Yup.array().min(1, 'Please select at least one option'),
  }),

  children: Yup.array().when(['app_types', 'vary_resp_children'], {
    is: (app_types: string[], vary_resp_children: string) =>
      Array.isArray(app_types) &&
      app_types.includes('AV') &&
      vary_resp_children === 'yes',
    then: Yup.array().of(child()),
  }),

  app_type_extend_further_violence_check: Yup.string().when('app_types', {
    is: (app_types: string[]) =>
      Array.isArray(app_types) &&
      (app_types.includes('AE') || app_types.includes('AV')),
    then: Yup.string().required(
      'Please indicate whether the respondent has committed family violence since the original order was issued'
    ),
  }),

  app_type_extend_further_violence: Yup.array().when(
    'app_type_extend_further_violence_check',
    {
      is: 'yes',
      then: Yup.array()
        .ensure()
        .min(
          1,
          'Please select at least one type of family violence that has occurred since the original order'
        ),
    }
  ),

  incident_pys: Yup.array().when(
    [
      'app_type_extend_further_violence',
      'app_type_extend_further_violence_check',
    ],
    {
      is: (violence: string[], check: string) =>
        check === 'yes' &&
        Array.isArray(violence) &&
        violence.includes('incident_pys'),
      then: Yup.array()
        .ensure()
        .min(1, 'Please select at least one option'),
    }
  ),

  incident_thy: Yup.array().when(
    [
      'app_type_extend_further_violence',
      'app_type_extend_further_violence_check',
    ],
    {
      is: (violence: string[], check: string) =>
        check === 'yes' &&
        Array.isArray(violence) &&
        violence.includes('incident_thy'),
      then: Yup.array()
        .ensure()
        .min(1, 'Please select at least one option'),
    }
  ),

  incident_fsw_detail: Yup.string().when(
    [
      'app_type_extend_further_violence',
      'app_type_extend_further_violence_check',
    ],
    {
      is: (violence: string[], check: string) =>
        check === 'yes' &&
        Array.isArray(violence) &&
        violence.includes('incident_fsw'),
      then: Yup.string()
        .required('Please provide details of the incidents that have occurred')
        .csvNarrativeLimit('Character limit exceeded for other details'),
    }
  ),

  app_type_extend_why_breached: Yup.string().when(
    'app_type_extend_further_violence_check',
    {
      is: 'yes',
      then: Yup.string()
        .required('Please provide details of the incidents that have occurred')
        .csvNarrativeLimit(
          'Character limit exceeded for specific incident details'
        ),
    }
  ),

  app_type_extend_why_violence_stopped: Yup.string().when(
    'app_type_extend_further_violence_check',
    {
      is: 'no',
      then: Yup.string()
        .required('Please provide more details')
        .csvNarrativeLimit('Character limit exceeded for incident details'),
    }
  ),

  app_type_extend_still_fearful: Yup.string().when('app_types', {
    is: (app_types: string[]) =>
      Array.isArray(app_types) &&
      (app_types.includes('AE') || app_types.includes('AV')),
    then: Yup.string().required(
      'Please indicate your level of fear on a scale of 1 to 5'
    ),
  }),

  app_type_extend_duration: Yup.string()
    .csvDuration(['Months', 'Years'])
    .when('app_types', {
      is: (app_types: string[]) =>
        Array.isArray(app_types) && app_types.includes('AE'),
      then: Yup.string().required(
        'Please enter the duration for which you want the order to be extended.'
      ),
    }),

  appl_pregnant_baby: Yup.string().when('app_types', {
    is: (app_types: string[]) =>
      Array.isArray(app_types) &&
      (app_types.includes('AE') || app_types.includes('AV')),
    then: Yup.string().required(
      'Please indicate whether you are pregnant or have a child under 6 months'
    ),
  }),

  revoke_appl_why: Yup.string().when('app_types', {
    is: (app_types: string[]) =>
      Array.isArray(app_types) && app_types.includes('AR'),
    then: Yup.string()
      .trim()
      .required(
        'Please provide details of what has changed since the order was made'
      )
      .max(250, 'Character limit exceeded for reasons to revoke the order'),
  }),
};

export default applicationType;
